import { Flex } from '@banhala/ui-kit';
import { isNil } from '../../../../utils';
import { SummaryCard } from './components/SummaryCard';
import type { SummaryProps } from './types';

export const Summary = ({ entity }: SummaryProps) => {
  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <Flex.Column gap={12} padding={{ vertical: 8 }}>
      {entity.map((summaryItem, index) => (
        <SummaryCard
          key={index}
          item={summaryItem.item}
          logging={summaryItem.logging}
        />
      ))}
    </Flex.Column>
  );
};
